<nav class="nav-content fixed-top">
  <div class="nav-left">
    <span class="toggle-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M4 5H16"
          stroke="#98A0AE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 12H20"
          stroke="#98A0AE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 19H12"
          stroke="#98A0AE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    @if (pageTitle) {
      <div class="page-heading">
        <span class="page-eyebrow">{{ eyebrow }}</span>
        <span class="page-title">{{ pageTitle }}</span>
      </div>
    }
    <div class="input-group nav-search d-none">
      <input
        type="text"
        class="my-form-control"
        placeholder="Search "
        aria-label="Recipient's username"
        aria-describedby="button-addon2"
      />
      <div class="btn-search" type="button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M2.29695 6.87102C2.29695 5.25202 2.74874 4.14857 3.44856 3.44877C4.14837 2.74896 5.25182 2.29715 6.8708 2.29715C8.48979 2.29715 9.59325 2.74896 10.2931 3.44877C10.9929 4.14857 11.4446 5.25202 11.4446 6.87102C11.4446 8.49 10.9929 9.59345 10.2931 10.2933C9.59325 10.9931 8.48979 11.4449 6.8708 11.4449C5.25182 11.4449 4.14837 10.9931 3.44856 10.2933C2.74874 9.59345 2.29695 8.49 2.29695 6.87102ZM6.8708 0.0114403C4.83109 0.0114403 3.07618 0.588646 1.83231 1.83253C0.588437 3.0764 0.0112305 4.8313 0.0112305 6.87102C0.0112305 8.91073 0.588437 10.6656 1.83231 11.9095C3.07618 13.1534 4.83109 13.7306 6.8708 13.7306C8.46223 13.7306 9.88028 13.3792 11.0175 12.6339L14.0316 15.6483C14.478 16.0946 15.2016 16.0946 15.648 15.6483C16.0942 15.2021 16.0942 14.4784 15.648 14.0321L12.6338 11.0177C13.379 9.88051 13.7304 8.46246 13.7304 6.87102C13.7304 4.8313 13.1532 3.0764 11.9093 1.83253C10.6654 0.588646 8.91052 0.0114403 6.8708 0.0114403Z"
            fill="#98A0AE"
          />
        </svg>
      </div>
    </div>
  </div>
  <div class="nav-right">
    <div class="qa-wrap">
      <button
        type="button"
        class="add-label"
        (click)="toggleQuickAdd()"
        [attr.aria-expanded]="quickAddOpen"
        aria-haspopup="dialog"
      >
        <span class="add-plus">+</span>
        Add Quick Item
      </button>

      @if (quickAddOpen) {
        <div class="qa-panel" role="dialog" aria-label="Quick add">
          <div class="qa-head">
            <div>
              <p class="qa-title">Quick Add</p>
              <p class="qa-sub">Instantly create new POS schema items</p>
            </div>
            <button type="button" class="qa-close" (click)="closeQuickAdd()" aria-label="Close">
              <i class="bx bx-x-circle" aria-hidden="true"></i>
            </button>
          </div>

          <div class="qa-grid">
            @for (item of visibleQuickAddItems; track item.key) {
              <button
                type="button"
                class="qa-card"
                [ngClass]="{ 'qa-disabled': isQuickAddDisabled(item) }"
                (click)="runQuickAdd(item)"
              >
                <span class="qa-icon" [class]="'qa-icon qa-icon--' + item.key">
                  <i [class]="item.icon" aria-hidden="true"></i>
                </span>
                <span class="qa-label">{{ item.label }}</span>
                <span class="qa-hint">{{ item.hint }}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>

    @if (closureChip) {
      <a
        class="closure-chip"
        routerLink="/main/restaurant-profile"
        [queryParams]="{ section: 'status' }"
        title="The restaurant is temporarily closed. Open Restaurant Status to reopen."
        data-testid="closure-chip"
      >
        <span class="closure-dot" aria-hidden="true"></span>
        {{ closureChip }}
      </a>
    }

    @if (posNotSelected) {
      <a
        class="pos-configure"
        [routerLink]="configurePosLink"
        title="No POS provider selected yet"
        aria-label="Configure POS provider"
      >
        <i class="bx bx-cog" aria-hidden="true"></i>
        Configure POS
      </a>
    } @else if (posBadge) {
      @if (canOpenHardware) {
        <a
          class="pos-badge"
          routerLink="/main/hardware"
          title="POS provider"
          [attr.aria-label]="'POS provider: ' + posBadge.label"
        >
          <img [src]="posBadge.logo" alt="" />
          <span>{{ posBadge.label }}</span>
        </a>
      } @else {
        <span
          class="pos-badge"
          title="POS provider"
          [attr.aria-label]="'POS provider: ' + posBadge.label"
        >
          <img [src]="posBadge.logo" alt="" />
          <span>{{ posBadge.label }}</span>
        </span>
      }
    }

    <a
      class="nav-bell"
      routerLink="/main/notifications"
      aria-label="Notifications"
      [attr.data-unread]="(unreadCount$ | async) || 0"
    >
      <i class="bx bx-bell" aria-hidden="true"></i>
      @if ((unreadCount$ | async) || 0; as unread) {
        <span class="nav-bell-badge">{{ unread > 99 ? '99+' : unread }}</span>
      }
    </a>

    <div class="nav-icon dropdown mx-2" hidden>
      <div class="" data-bs-toggle="dropdown" aria-expanded="false">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M2.52992 14.7696C2.31727 16.1636 3.268 17.1312 4.43205 17.6134C8.89481 19.4622 15.1052 19.4622 19.5679 17.6134C20.732 17.1312 21.6827 16.1636 21.4701 14.7696C21.3394 13.9129 20.6932 13.1995 20.2144 12.5029C19.5873 11.5793 19.525 10.5718 19.5249 9.5C19.5249 5.35786 16.1559 2 12 2C7.84413 2 4.47513 5.35786 4.47513 9.5C4.47503 10.5718 4.41272 11.5793 3.78561 12.5029C3.30684 13.1995 2.66061 13.9129 2.52992 14.7696Z"
            stroke="#98A0AE"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M8 19C8.45849 20.7252 10.0755 22 12 22C13.9245 22 15.5415 20.7252 16 19"
            stroke="#98A0AE"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <ul class="dropdown-menu dropdown-menu-end">
        <li><a class="dropdown-item" href="#">Another action</a></li>
        <li><a class="dropdown-item" href="#">Something else here</a></li>
      </ul>
    </div>

    <div class="nav-icon dropdown mx-2" hidden>
      <div class="" data-bs-toggle="dropdown" aria-expanded="false">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M8 13.5H16M8 8.5H12"
            stroke="#98A0AE"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5"
            stroke="#98A0AE"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <ul class="dropdown-menu">
        <li><a class="dropdown-item" href="#">Notification 1</a></li>
        <li><a class="dropdown-item" href="#">Another action</a></li>
        <li><a class="dropdown-item" href="#">Something else here</a></li>
      </ul>
    </div>

    <div class="profile-img dropdown mx-3">
      <div class="btn-profile" data-bs-toggle="dropdown" aria-expanded="false">
        <img class="avatar" [src]="login_user_img_url" (error)="onImageError($event)" />
        @if (userName) {
          <div class="user-meta">
            <span class="user-name">{{ userName }}</span>
            <span class="user-role">{{ userRole }}</span>
          </div>
        }
      </div>
      <ul class="dropdown-menu">
        @if (canAccess('profile')) {
          <li>
            <a class="dropdown-item" routerLink="profile"><i class="bx bx-user pe-3"></i>Profile</a>
          </li>
        }
        @if (canAccess('change-password')) {
          <li>
            <a class="dropdown-item" routerLink="change-password"
              ><i class="bx bx-lock-alt pe-3"></i>Change Password</a
            >
          </li>
        }
        <li (click)="logout()">
          <a class="dropdown-item" href="#"><i class="bx bx-log-out pe-3"></i>Logout</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
